import React, { useState, useContext, useEffect } from 'react'
import Loader from '../../../utils/Loader'
import { DataContext } from "../../../Context/HelperOne";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LoanCreate from './LoanCreate';
import { Fragment } from 'react'
import { Dialog, Transition } from "@headlessui/react";
import LoanEdite from './LoanEdite';
import LoanView from './LoanView';

const LoanList = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { searchData } = useContext(DataContext);
  const navigate = useNavigate();
  const [loanCreateOpen, setLoanCreateOpen] = useState(false)
  const [loanEditOpen, setLoanEditOpen] = useState(false)
  const [loanList, setLoanList] = useState(false);
  const [paginationData, setPaginationData] = useState(null);
  const [loanId, setLoanId] = useState(null)
  const [loanView, setLoanView] = useState(false)




  const fetch = async (page = 1) => {
    setLoading(true)
    try {
      const token = localStorage.getItem("token");
      let endpoint = `public/api/loans?page=${page}`;
      if (searchData) {
        endpoint += `&search=${searchData}`;
      }
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      setLoanList(response?.data?.data)
      setPaginationData(response?.data)
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("token");
        navigate("/crm");
      }
      setError(error.response.data.messaage || " Please check your internet connection and try again.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetch()
  }, [])


  const handleClick = () => {
    setLoanCreateOpen(true)
  }

  const handleClose = () => {
    setLoanCreateOpen(false);
    setLoanEditOpen(false)
    setLoanView(false)
    fetch()
  }

  const handleClickForEdit = (id) => {
    setLoanId(id?.id);
    setLoanEditOpen(true);
  };

  const handleClickForView = (id) => {
    setLoanId(id?.id);
    setLoanView(true)
  }

  if (loading) {
    return (
      <Loader />
    )
  }

  if (error) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md">
          <div className="flex items-center justify-center mb-6">
            <svg
              className="h-12 w-12 text-red-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <p className="text-gray-600 mb-8 text-center">
            Please check your internet connection and try again.
          </p>
          <div className="flex justify-center">
            <button
              className="bg-[#0f172a] hover:bg-teal-900 text-white font-semibold py-2 px-4 rounded transition duration-300"
              onClick={fetch}
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    )

  }
  return (
    <div>
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className=" font-semibold text-3xl text-gray-900">Loan</h1>
            <p className="mt-2 text-sm text-gray-700">
              Manage all your chit fund loan and their details..
            </p>
          </div>
          <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
            <button
              type="button"
              onClick={handleClick}
              className="block rounded-md bg-[#0f172a] px-3 py-2 text-center text-sm font-semibold text-white shadow-xs hover:bg-teal-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Loan
            </button>
          </div>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2  rounded-md align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow-sm  sm:rounded-lg">
              <table className="min-w-full divide-y  divide-gray-300 shadow-xl">
                <thead className=" text-white  bg-[#0f172a]">
                  <tr>

                    <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                      #
                    </th>
                    <th scope="col" className="py-3.5 pr-3 pl-4 text-left text-sm font-semibold  sm:pl-6">
                      Finance Customer
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                      Loan Start Date
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                      Loan Amount
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                      Interest Rate
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                      Interest Type
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold ">
                      Status
                    </th>

                    <th scope="col" className="relative py-3.5 pr-4 pl-3 sm:pr-6">
                      Action
                    </th>
                  </tr>





                </thead>

                <tbody className="divide-y divide-gray-200 bg-white ">

                  {loanList.length > 0 ? (
                    loanList?.map((person, index) => (
                      <tr
                        key={index}
                        className='hover:bg-gray-50'
                      >
                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                          {paginationData.from + index}
                        </td>

                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6 capitalize">
                          {person?.customer_name?.name}
                        </td>
                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                          {person?.loan_start_date}
                        </td>

                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                          {person?.loan_amount}
                        </td>
                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                          {person?.interest_rate}
                        </td>
                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6 capitalize">
                          {person?.interest_type?.replace('_', ' ')}
                        </td>

                        <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap sm:pl-6">
                          <span
                            className={`px-3 py-1 rounded-full text-xs font-semibold capitalize
      ${person?.status === "active"
                                ? "bg-green-100 text-green-700"
                                : "bg-red-100 text-red-700"
                              }`}
                          >
                            {person?.status}
                          </span>
                        </td>

                        <td className="px-3 py-4  text-center text-sm font-medium whitespace-nowrap sm:pr-6 gap-2">


                          <button
                            type="button"
                            className=" rounded bg-white px-5 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"
                            onClick={() =>
                              handleClickForView(person)
                            }

                          >
                            View
                          </button>
                          {/* <button
                            type="button"
                            className="rounded bg-white px-5 py-2 text-sm ml-2 font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"

                           onClick={() =>
                              handleClickForEdit(person)
                            }
                          >
                            Edit
                          </button> */}
                          <button
                            type="button"
                            className="rounded bg-white px-5 py-2 text-sm ml-2 font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-100"

                          // onClick={() =>
                          //   Delete(person.id)
                          // }
                          >
                            Delete
                          </button>
                        </td>
                      </tr>

                    ))
                  ) : (
                    <tr>
                      <td className="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                        No Loan
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

        </div>

      </div>


      <Transition.Root show={loanCreateOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => { }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8   md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <LoanCreate
                      close={handleClose}
                    // closeModal={closeModal}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Transition.Root show={loanEditOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => { }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8   md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <LoanEdite
                      close={handleClose}
                      idCrypt={loanId}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={loanView} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => { }}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-90 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8   md:max-w-screen-md lg:max-w-screen-lg sm:w-full">
                  <div>
                    <LoanView
                      close={handleClose}
                      idCrypt={loanId}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

    </div>
  )
}

export default LoanList
